export const FAILED_CHECK_MESSAGES: Record<string, string> = {
  balance: "Wallet balance is below the minimum requirement",
  minimumBalance: "Wallet balance is below the minimum requirement",
  walletAge: "Wallet does not meet the minimum age requirement",
  transactionCount: "Wallet does not have enough on-chain transactions",
};
